export const data = [
  { note: 0, male: 100, female: 500 },
  { note: 1, male: 50, female: 30 },
  { note: 2, male: 750, female: 200 },
  { note: 3, male: 600, female: 300 },
  { note: 4, male: 500, female: 100 },
  { note: 5, male: 250, female: 70 },
  { note: 6, male: 250, female: 80 },
  { note: 7, male: 400, female: 110 },
  { note: 8, male: 100, female: 40 },
  { note: 9, male: 350, female: 240 },
  { note: 10, male: 20, female: 50 },
];

export const data03 = [
  { ageGroup: "75-90", male: 10, female: 55 },
  { ageGroup: "74-75", male: 15, female: 50 },
  { ageGroup: "65-69", male: 20, female: 45 },
  { ageGroup: "55-64", male: 25, female: 40 },
  { ageGroup: "45-54", male: 30, female: 35 },
  { ageGroup: "35-44", male: 35, female: 30 },
  { ageGroup: "25-34", male: 40, female: 25 },
  { ageGroup: "15-24", male: 45, female: 20 },
  { ageGroup: "5-14", male: 50, female: 15 },
  { ageGroup: "0-4", male: 55, female: 10 },
];

export const indicatorsMap = {
  promotorM: {
    className: "promotor",
    text: "Promotor(M)",
    gender: "M",
  },
  neutroM: {
    className: "neutro",
    text: "Neutro(M)",
    gender: "M",
  },
  detratorM: {
    className: "detrator",
    text: "Detrator(M)",
    gender: "M",
  },
  promotorF: {
    className: "promotor",
    text: "Promotor(F)",
    gender: "F",
  },
  neutroF: {
    className: "neutro",
    text: "Neutro(F)",
    gender: "F",
  },
  detratorF: {
    className: "detrator",
    text: "Detrator(F)",
    gender: "F",
  },
};

export const indicatorsMap02 = {
  male: {
    className: "male",
    text: "Masculino",
  },
  female: {
    className: "female",
    text: "Feminino",
  },
};

export const data02 = [
  { categoria: "Bom", valor: 7 },
  { categoria: "Ruim", valor: 3 },
];

export const classificationZoneOneData = [
  {
    name: "Equipe",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Infraestrutura",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Organização e limpeza",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Tempo de espera",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Experiência no atendimento",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Clareza nas informações",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
];

export const classificationZoneTwoData = [
  {
    name: "Experiência na aplicação",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Prazo de entrega",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Experiência na recepção",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Experiência na coleta",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Desejum",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
  {
    name: "Experiência no atend. médico",
    data: [
      { categoria: "Bom", valor: 7 },
      { categoria: "Ruim", valor: 3 },
    ],
  },
];
